import { render, staticRenderFns } from "./SubareaSelector.vue?vue&type=template&id=46885ffb&scoped=true"
import script from "./SubareaSelector.vue?vue&type=script&lang=js"
export * from "./SubareaSelector.vue?vue&type=script&lang=js"
import style0 from "./SubareaSelector.vue?vue&type=style&index=0&id=46885ffb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46885ffb",
  null
  
)

export default component.exports